export default "/assets/fb8b3db518f609e0.png"